import { AIContent } from '../conversations/ChatMessage';

/** functionCall 콘텐츠(타입 이름) 으로 분기 */
export interface FunctionCallContent extends AIContent {
  $type: 'functionCall';
  name: string;
  callId: string;
  arguments: Record<string, unknown>;
  status?: 'awaiting' | 'submitted' | 'cancelled';
  response?: Record<string, unknown>;
}

export const isFunctionCallContent = (obj: unknown): obj is FunctionCallContent =>
  obj !== null &&
  typeof obj === 'object' &&
  '$type' in obj &&
  (obj as { $type: unknown }).$type === 'functionCall';

/** 표준화 */
export function normalizeFunctionCall(raw: unknown): FunctionCallContent | null {
  if (!raw || typeof raw !== 'object') return null;
  const data = raw as Record<string, unknown>;
  if (data.$type !== 'functionCall') return null;

  return {
    $type: 'functionCall',
    name: (data.name ?? data.Name ?? '') as string,
    callId: (data.callId ?? data.CallId ?? '') as string,
    arguments: (data.arguments ?? data.Arguments ?? {}) as Record<string, unknown>,
    status: 'awaiting',
    additionalProperties: {} as Record<string, object>,
  };
}

export interface ToolApprovalRequestContent extends AIContent {
  $type: 'toolApprovalRequest';
  toolCall: {
    $type: 'functionCall';
    name: string;
    arguments: Record<string, unknown>;
    callId: string;
  };
  requestId?: string;
}

export const isToolApprovalRequestContent = (obj: unknown): obj is ToolApprovalRequestContent =>
  obj !== null &&
  typeof obj === 'object' &&
  '$type' in obj &&
  (obj as { $type: unknown }).$type === 'toolApprovalRequest';


export interface ApprovalRequest {
  approval_id: string;
  function_name: string;
  function_arguments: Record<string, unknown>;
  message: string;
}

export function parseApprovalRequest(args: Record<string, unknown> | undefined): ApprovalRequest | null {
  const raw = args?.request;
  if (typeof raw !== 'string') return null;
  try {
    const parsed = JSON.parse(raw) as Partial<ApprovalRequest>;
    if (!parsed.function_name || !parsed.function_arguments) return null;
    return {
      approval_id: parsed.approval_id ?? '',
      function_name: parsed.function_name,
      function_arguments: parsed.function_arguments,
      message: parsed.message ?? '',
    };
  } catch {
    return null;
  }
}

